export const SET_GLOBAL_USERS_LIST = 'SET_GLOBAL_USERS_LIST';
export const SET_ACTIVE_PROGRAM_DETAILS = 'SET_ACTIVE_PROGRAM_DETAILS';
export const SET_ACTIVE_MODEL_DETAILS = 'SET_ACTIVE_MODEL_DETAILS';
export const SET_ALL_USERS_LIST = 'SET_ALL_USERS_LIST';
export const SET_ALL_PROGRAM_DETAILS = 'SET_ALL_PROGRAM_DETAILS';
